import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import {
	tap,
	switchMap,
	distinctUntilChanged,
	debounceTime,
	catchError
} from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Client } from '../services/client';
import { errorMessages } from '../../../../src/assets/constants.json';

@Component({
	selector: 'app-establecimiento-search',
	templateUrl: './establecimiento-search.component.html'
})
export class EstablecimientoSearchComponent {
	@Input() selectedEstablecimiento: any = null;
	@Input() showAll = true;
	selectedEstablecimientoModel: any = null;
	searchFailed = false;
	searching = false;

	@Input() readonly = false;
	@Output() select: EventEmitter<any> = new EventEmitter<any>();
	@Output() textChanged: EventEmitter<any> = new EventEmitter<any>();

	constructor(public router: Router, public client: Client, private alertService: AlertService) {
	}

	buscarEstablecimiento = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(300),
			distinctUntilChanged(),
			tap(() => this.searching = true),
			switchMap(term =>
				this.client.establecimientos_SearchEstablecimiento(term, this.showAll).pipe(
					tap(() => this.searchFailed = false),
					catchError((error) => {
						this.searchFailed = true;
						const errorMessage = error.status === 0 ?
							errorMessages.connectionError : !!error.title ? error.title : errorMessages.genericError;
						this.alertService.danger(errorMessage);
						return of([]);
					}))
			),
			tap(() => this.searching = false)
		)

	establecimientoFormatter = (x: { name: string }) => x.name;

	onSelect($event) {
		this.selectedEstablecimientoModel = $event;
		this.select.emit($event);
	}

	onModelTextChange() {
		this.selectedEstablecimientoModel = null;
		this.textChanged.emit(this.selectedEstablecimientoModel);
	}
}
